import React from 'react';
import { Box, useTheme } from '@mui/material';
import { DocsMain } from '../components/docs';

const TextEditorPage = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  
  return (
    <Box sx={{ 
      width: '100%',
      minHeight: '100vh',
      backgroundColor: isDark ? '#0F172A' : theme.palette.background.default, // Explicit background
      overflow: 'auto', // Allow scrolling
      p: 1.5 // Restore some padding for proper spacing
    }}>
      <DocsMain />
    </Box>
  );
};

export default TextEditorPage;
